import React, { useState } from 'react';
import { Alert, Button, Form } from 'react-bootstrap';
import apiFetch from '../../../utils/apiFetch';
import { DIVINE_ORDERS, getDivineOrder } from '../../../shared/rules/divineOrder';
import { BLESSED_STRIKES_OPTIONS, getBlessedStrikes } from '../../../shared/rules/cleric.mjs';

/** A class choice made once, saved at `classState.<classId>.<stateKey>`. */
export function ClassChoice({ form, characterId, onCharacterChange, classId = 'cleric', label, stateKey, route, bodyKey, options, getChoice }) {
  const [saved, setSaved] = useState(null);
  const current = saved || getChoice(form);
  const [selected, setSelected] = useState(options[0].id);
  const [saving, setSaving] = useState(false), [error, setError] = useState('');
  if (current) return <div className="fighting-style-chooser">
    <p className="feature-sheet-hint">{current.name}</p>
    <p className="fighting-style-description">{current.summary}</p>
  </div>;
  const choose = async () => {
    if (saving) return;
    setSaving(true); setError('');
    try {
      const response = await apiFetch(`/characters/${encodeURIComponent(characterId)}/classes/${classId}/${route}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ [bodyKey]: selected }),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.message || `Could not save ${label}.`);
      setSaved(options.find(option => option.id === result[stateKey].id));
      onCharacterChange?.(previous => ({ ...previous, ...(result.occupation ? { occupation: result.occupation } : {}),
        classState: { ...previous.classState, [classId]: { ...previous.classState?.[classId], [stateKey]: result[stateKey] } } }));
    } catch (failure) { setError(failure.message); }
    finally { setSaving(false); }
  };
  return <div className="fighting-style-chooser">
    <p className="feature-sheet-hint">Choose one option. This choice is permanent.</p>
    {error && <Alert variant="danger">{error}</Alert>}
    <Form.Label htmlFor={`${classId}-${route}`}>{label}</Form.Label>
    <Form.Select id={`${classId}-${route}`} value={selected} disabled={saving} onChange={event => setSelected(event.target.value)}>
      {options.map(option => <option key={option.id} value={option.id}>{option.name}</option>)}
    </Form.Select>
    <p className="fighting-style-description">{options.find(option => option.id === selected)?.summary}</p>
    <div className="fighting-style-actions"><Button size="sm" onClick={choose} disabled={saving}>{saving ? 'Saving…' : `Save ${label}`}</Button></div>
  </div>;
}

/** Cleric 1: choose Protector or Thaumaturge. */
export function DivineOrderChooser(props) {
  return <ClassChoice {...props} label="Divine Order" stateKey="divineOrder" route="divine-order" bodyKey="orderId" options={DIVINE_ORDERS} getChoice={getDivineOrder}/>;
}

/** Cleric 7: choose Divine Strike or Potent Spellcasting. */
export function BlessedStrikesChooser(props) {
  return <ClassChoice {...props} label="Blessed Strikes" stateKey="blessedStrikes" route="blessed-strikes" bodyKey="optionId" options={BLESSED_STRIKES_OPTIONS} getChoice={getBlessedStrikes}/>;
}
